if (!customElements.get('uis24-product-recommendations')) {
  customElements.define(
    'uis24-product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;

        const hasStaticRecommendations =
          this.dataset.source === 'static' && this.querySelector('.uis24-related-products__list')?.children.length;
        if (hasStaticRecommendations) {
          this.classList.add('is-loaded');
          return;
        }

        if (hasStaticRecommendations || !('IntersectionObserver' in window)) {
          if (!hasStaticRecommendations) this.load();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      }

      async load() {
        this.dataset.loaded = 'true';

        try {
          const loadedComplementary = await this.loadIntent('complementary');
          if (!loadedComplementary) await this.loadIntent('related');
        } catch (error) {
          console.error('Product recommendations could not be loaded.', error);
        }
      }

      async loadIntent(intent) {
        const params = new URLSearchParams({
          section_id: this.dataset.sectionId,
          product_id: this.dataset.productId,
          limit: this.dataset.limit || '4',
          intent,
        });
        const response = await fetch(`${this.dataset.url}?${params.toString()}`);
        if (!response.ok) return false;

        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const replacement = html.querySelector(`uis24-product-recommendations.${this.classList.contains('uis24-related-products--desktop') ? 'uis24-related-products--desktop' : 'uis24-related-products--mobile'}`);
        const list = replacement?.querySelector('.uis24-related-products__list');
        if (!replacement || replacement.dataset.source !== 'api' || !list?.children.length) return false;

        this.innerHTML = replacement.innerHTML;
        this.dataset.source = 'api';
        if (intent === 'related') {
          const heading = this.querySelector('.uis24-related-products__heading');
          const intro = this.querySelector('.uis24-related-products__intro');
          if (heading) heading.textContent = 'Ähnliche Produkte';
          if (intro) intro.textContent = 'Weitere Artikel aus derselben Produktfamilie.';
        }
        this.classList.add('is-loaded');
        return true;
      }
    }
  );
}
